module.exports = __webpack_public_path__ + "img/202407_01.0e6c1a27.jpg";